<script>
/**
 * This mixin provides animation methods
 * It's not meant to be used directly.
 *
 * @mixin
 */
export default {
    data: () => ({
        /**
         * expandTransition duration, to be overridden in the mounted() hook whenever we want the
         * duration of the transition to last more/less
         */
        expandTransitionDuration: '300ms'
    }),
    methods: {
        afterEnter (element) {
            element.style.height = 'auto';
        },
        enter (element) {
            const width = getComputedStyle(element).width;
            element.style.width = width;
            element.style.position = 'absolute';
            element.style.visibility = 'hidden';
            element.style.height = 'auto';

            const height = getComputedStyle(element).height;

            element.style.width = null;
            element.style.position = null;
            element.style.visibility = null;
            element.style.height = 0;
            element.style.opacity = 0;
            element.style.transition = `all ${this.expandTransitionDuration}`;

            /* Force repaint to make sure the animation is triggered correctly.*/
            getComputedStyle(element).height;

            /** Trigger the animation.
            * We use `requestAnimationFrame` because we need
            * to make sure the browser has finished
            * painting after setting the `height`
            * to `0` in the line above.
            */
            requestAnimationFrame(() => {
                element.style.transitionTimingFunction = 'cubic-bezier(.63, .01, 1, 1.01)';
                element.style.height = height;
                element.style.opacity = 1;
            });
        },
        leave (element) {
            const height = getComputedStyle(element).height;

            element.style.height = height;

            /* Force repaint to make sure the animation is triggered correctly. */
            getComputedStyle(element).height;

            requestAnimationFrame(() => {
                element.style.transitionTimingFunction = 'cubic-bezier(.63, .01, 1, 1.01)';
                element.style.height = 0;
                element.style.opacity = 0;
            });
        }
    }
};
</script>
